@if (valueAddedTaxEntity$ | async) {
  <form [formGroup]="btwAangiftenFg">
    <div class="row">
      <div formArrayName="suppleties">
        @for (item of suppleties.controls; let i = $index; track $index) {
          <div [formGroupName]="i">
            @if (this.index === $index) {
              @if (item.get('verzendDatum')?.getRawValue() != null) {
                <div class="row">
                  <div class="col col-1">
                    <p>Datum ingediend</p>
                  </div>
                  <div class="col-2">
                    <div style="height: 20px; width: 160px"></div>
                  </div>
                  <div class="col-3">
                    <snelstart-ui-date-form-control class="me-1 custom-input-150"
                                                    formControlName="verzendDatum"
                                                    id="verzendDatum"
                                                    label=""
                    >
                    </snelstart-ui-date-form-control>
                  </div>
                  <div class="col-4">
                    <div style="height: 20px; width: 160px"></div>
                  </div>
                </div>
              }
              <div formGroupName="tijdvak">
                <div>
                  <div class="row">
                    <div class="col col-1">
                      <p>Aanvang tijdvak</p>
                    </div>
                    <div class="col-2">
                      <div style="height: 20px; width: 160px"></div>
                    </div>
                    <div class="col-3">
                      <snelstart-ui-date-form-control class="me-1 custom-input-150"
                                                      formControlName="begindatum"
                                                      id="begindatum"
                                                      label=""
                      >
                      </snelstart-ui-date-form-control>
                    </div>
                    <div class="col-4">
                      <div style="height: 20px; width: 160px"></div>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="row">
                    <div class="col col-1">
                      <p>Einde tijdvak</p>
                    </div>
                    <div class="col-2">
                      <div style="height: 20px; width: 160px"></div>
                    </div>
                    <div class="col-3">
                      <snelstart-ui-date-form-control class="me-1 custom-input-150"
                                                      formControlName="einddatum"
                                                      id="einddatum"
                                                      label=""
                      >
                      </snelstart-ui-date-form-control>
                    </div>
                    <div class="col-4">
                      <div style="height: 20px; width: 160px"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div formGroupName="omzetHoog">
                <div class="pt-2">
                  <div class="row">
                    <div class="col col-1 pt-3">
                      <p>Omzet hoog tarief</p>
                    </div>
                    <div class="col-2">
                      <div style="height: 20px; width: 160px"></div>
                    </div>
                    <div class="col-3">
                      <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                        align="right"
                                                        class="me-1 custom-input-150"
                                                        formControlName="omzet"
                                                        id="omzetHoog"
                                                        label="Omzet"
                                                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                    <div class="col-4">
                      <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                        align="right"
                                                        class="me-1 custom-input-150"
                                                        formControlName="omzetbelasting"
                                                        id="omzetbelastingHoog"
                                                        label="Omzetbelasting"
                                                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                  </div>
                </div>
              </div>
              <div formGroupName="omzetLaag">
                <div>
                  <div class="row">
                    <div class="col col-1">
                      <p>Omzet laag tarief</p>
                    </div>
                    <div class="col-2">
                      <div style="height: 20px; width: 160px"></div>
                    </div>
                    <div class="col-3">
                      <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                        align="right"
                                                        class="me-1 custom-input-150"
                                                        formControlName="omzet"
                                                        id="omzetLaag"
                                                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                    <div class="col-4">
                      <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                        align="right"
                                                        class="me-1 custom-input-150"
                                                        formControlName="omzetbelasting"
                                                        id="omzetbelastingLaag"
                                                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                  </div>
                </div>
              </div>
              <div formGroupName="omzetOverigTarief">
                <div>
                  <div class="row">
                    <div class="col col-1">
                      <p>Omzet overig tarief</p>
                    </div>
                    <div class="col-2">
                      <div style="height: 20px; width: 160px"></div>
                    </div>
                    <div class="col-3">
                      <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                        align="right"
                                                        class="me-1 custom-input-150"
                                                        formControlName="omzet"
                                                        id="omzetOverigTarief"
                                                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                    <div class="col-4">
                      <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                        align="right"
                                                        class="me-1 custom-input-150"
                                                        formControlName="omzetbelasting"
                                                        id="omzetOverigTariefBelasting"
                                                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                  </div>
                </div>
              </div>
              <div formGroupName="privegebruik">
                <div>
                  <div class="row">
                    <div class="col col-1">
                      <p>Privé-gebruik</p>
                    </div>
                    <div class="col-2">
                      <div style="height: 20px; width: 160px"></div>
                    </div>
                    <div class="col-3">
                      <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                        align="right"
                                                        class="me-1 custom-input-150"
                                                        formControlName="omzet"
                                                        id="omzetprivegebruik"
                                                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                    <div class="col-4">
                      <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                        align="right"
                                                        class="me-1 custom-input-150"
                                                        formControlName="omzetbelasting"
                                                        id="omzetbelastingprivegebruik"
                                                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="row">
                  <div class="col col-1">
                    <p>Omzet nultarief</p>
                  </div>
                  <div class="col-2">
                    <div style="height: 20px; width: 160px"></div>
                  </div>
                  <div class="col-3">
                    <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                      align="right"
                                                      class="me-1 custom-input-150"
                                                      formControlName="omzetNul"
                                                      id="omzetNul"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-4">
                    <div style="height: 20px; width: 160px"></div>
                  </div>
                </div>
              </div>
              <div formGroupName="omzetVerlegdBinnenland">
                <div class="pt-2">
                  <div class="row">
                    <div class="col col-1">
                      <p>Verlegde omzet binnenland</p>
                    </div>
                    <div class="col-2">
                      <div style="height: 20px; width: 160px"></div>
                    </div>
                    <div class="col-3">
                      <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                        align="right"
                                                        class="me-1 custom-input-150"
                                                        formControlName="omzet"
                                                        id="omzetomzetVerlegdBinnenland"
                                                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                    <div class="col-4">
                      <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                        align="right"
                                                        class="me-1 custom-input-150"
                                                        formControlName="omzetbelasting"
                                                        id="omzetbelastingomzetVerlegdBinnenland"
                                                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="row">
                  <div class="col col-1">
                    <p>Omzet uit leveringen naar landen binnen EU</p>
                  </div>
                  <div class="col-2">
                    <div style="height: 20px; width: 160px"></div>
                  </div>
                  <div class="col-3">
                    <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                      align="right"
                                                      class="me-1 custom-input-150"
                                                      formControlName="leveringenNaarLandenBinnenDeEU"
                                                      id="leveringenNaarLandenBinnenDeEU"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-4">
                    <div style="height: 20px; width: 160px"></div>
                  </div>
                </div>
              </div>
              <div>
                <div class="row">
                  <div class="col col-1">
                    <p>Omzet uit leveringen naar landen buiten EU</p>
                  </div>
                  <div class="col-2">
                    <div style="height: 20px; width: 160px"></div>
                  </div>
                  <div class="col-3">
                    <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                      align="right"
                                                      class="me-1 custom-input-150"
                                                      formControlName="leveringenNaarLandenBuitenDeEU"
                                                      id="leveringenNaarLandenBuitenDeEU"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                  </div>
                  <div class="col-4">
                    <div style="height: 20px; width: 160px"></div>
                  </div>
                </div>
              </div>
              <div formGroupName="leveringenUitLandenBinnenDeEU">
                <div class="pt-2">
                  <div class="row">
                    <div class="col col-1">
                      <p>Ontvangen leveringen uit landen binnen EU</p>
                    </div>
                    <div class="col-2">
                      <div style="height: 20px; width: 160px"></div>
                    </div>
                    <div class="col-3">
                      <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                        align="right"
                                                        class="me-1 custom-input-150"
                                                        formControlName="omzet"
                                                        id="omzetleveringenUitLandenBinnenDeEU"
                                                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                    <div class="col-4">
                      <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                        align="right"
                                                        class="me-1 custom-input-150"
                                                        formControlName="omzetbelasting"
                                                        id="omzetbelastingleveringenUitLandenBinnenDeEU"
                                                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                  </div>
                </div>
              </div>
              <div formGroupName="leveringenUitLandenBuitendeEU">
                <div>
                  <div class="row">
                    <div class="col col-1">
                      <p>Ontvangen leveringen uit landen buiten EU</p>
                    </div>
                    <div class="col-2">
                      <div style="height: 20px; width: 160px"></div>
                    </div>
                    <div class="col-3">
                      <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                        align="right"
                                                        class="me-1 custom-input-150"
                                                        formControlName="omzet"
                                                        id="omzetleveringenUitLandenBuitendeEU"
                                                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                    <div class="col-4">
                      <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                        align="right"
                                                        class="me-1 custom-input-150"
                                                        formControlName="omzetbelasting"
                                                        id="omzetbelastingleveringenUitLandenBuitendeEU"
                                                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pt-2">
                <div class="row">
                  <div class="col col-1">
                    <p>Voorbelasting</p>
                  </div>
                  <div class="col-2">
                    <div style="height: 20px; width: 160px"></div>
                  </div>
                  <div class="col-3">
                    <div style="height: 20px; width: 160px"></div>
                  </div>
                  <div class="col-4">
                    <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                      align="right"
                                                      class="me-1 custom-input-150"
                                                      formControlName="voorbelasting"
                                                      id="voorbelasting"
                                                      prefix="€ -"
                    >
                    </snelstart-ui-number-form-control>
                  </div>
                </div>
              </div>
              <div formGroupName="suppletie">
                <div>
                  <div class="row">
                    <div class="col col-1">
                      <p>Totaal suppletie aangifte</p>
                    </div>
                    <div class="col-2">
                      <div style="height: 20px; width: 160px"></div>
                    </div>
                    <div class="col-3">
                      <div style="height: 20px; width: 160px"></div>
                    </div>
                    <div class="col-4">
                      <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                        [calculate]="calculateTotal(i)"
                                                        align="right"
                                                        class="me-1 custom-input-150"
                                                        formControlName="totaalNieuweAangifte"
                                                        id="totaalNieuweAangifte"
                                                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="row">
                    <div class="col col-1">
                      <p>Totaal eerdere aangifte(n)</p>
                    </div>
                    <div class="col-2">
                      <div style="height: 20px; width: 160px"></div>
                    </div>
                    <div class="col-3">
                      <div style="height: 20px; width: 160px"></div>
                    </div>
                    <div class="col-4">
                      <snelstart-ui-number-form-control [showAllDecimals]="false"
                                                        align="right"
                                                        class="me-1 custom-input-150"
                                                        formControlName="totaalOudeAangifte"
                                                        id="totaalOudeAangifte"
                                                        prefix="€"
                      >
                      </snelstart-ui-number-form-control>
                    </div>
                  </div>
                </div>
              </div>
              @if ((item.get('suppletie.totaalNieuweAangifte')?.value ?? 0) > (item.get('suppletie.totaalOudeAangifte')?.value ?? 0)) {
                <snelstart-ui-alert type="info">
                  De Belastingdienst zal een aanslag opleggen voor een bedrag van
                  € {{ (item.get('suppletie.totaalNieuweAangifte')?.value ?? 0) - (item.get('suppletie.totaalOudeAangifte')?.value ?? 0) | number: '1.0-0' }}.
                </snelstart-ui-alert>
              } @else if ((item.get('suppletie.totaalNieuweAangifte')?.value ?? 0) !== 0) {
                <snelstart-ui-alert type="info">
                  De Belastingdienst zal het bedrag van
                  € {{ (item.get('suppletie.totaalNieuweAangifte')?.value ?? 0) - (item.get('suppletie.totaalOudeAangifte')?.value ?? 0) * -1 | number: '1.0-0' | number: '1.0-0' }}
                  overmaken aan de belastingplichtige.
                </snelstart-ui-alert>
              }
            }
          </div>
        }
      </div>
    </div>
    <div style="width: 50%">
    </div>
  </form>


}


